// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CollapseMonitor_wrapper__1DobO","block":"CollapseMonitor_block__1cFYP"};